// The lesson drawn as its own timeline: each stage is a segment proportional to its minutes.
import type { DocStage } from "../../shared/lesson-model";

export function StageStrip({ stages, size = "md", active, progress, showLabels = false }: {
  stages: DocStage[];
  size?: "xs" | "md" | "lg" | "xl";
  active?: number;
  progress?: number; // 0..1 within the active stage
  showLabels?: boolean;
}) {
  const total = stages.reduce((a, s) => a + s.minutes, 0) || 1;
  const label = stages.map((s) => `${s.name} ${s.minutes} minutes`).join(", ");
  return (
    <div className={`strip strip-${size}`} role="img" aria-label={`Lesson timeline: ${label}`}>
      {stages.map((s, i) => (
        <div key={i} className={`seg seg-${s.kind}${active !== undefined && i < active ? " is-done" : ""}${i === active ? " is-active" : ""}`}
          style={{ flexGrow: s.minutes, flexBasis: 0 }} title={`${s.name} · ${s.minutes} min`}>
          {i === active && progress !== undefined && <span className="seg-progress" style={{ width: `${Math.min(100, progress * 100)}%` }} />}
          {showLabels && s.minutes / total > 0.09 && (
            <span className="seg-label">
              <b>{s.minutes}</b> {s.name}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
